import { render } from "./TankComponent.vue?vue&type=template&id=53195004"
import script from "./TankComponent.vue?vue&type=script&lang=js"
export * from "./TankComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__